"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Crown, Sparkles } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function JoinTheFoundersCircle() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="join-the-founders-circle" className="relative w-full bg-primary py-24 md:py-32 overflow-hidden">
      {}
      <div className="absolute inset-0 opacity-5 pointer-events-none bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1654300/img/foundation_pattern_lines.png)] bg-repeat bg-[length:100px_100px]" aria-hidden="true" />

      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-64 bg-chart-3/10 blur-[100px] rounded-full pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10">
        <div ref={ref} className={`max-w-4xl mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {}
          <div className="relative border-2 border-chart-3/60 rounded-3xl p-8 md:p-16 text-center bg-primary/40 backdrop-blur-sm shadow-2xl shadow-black/50">
            
            {}
            <div className="absolute top-0 left-0 w-8 h-8 border-t-2 border-l-2 border-chart-3 rounded-tl-3xl -translate-x-[2px] -translate-y-[2px]" />
            <div className="absolute top-0 right-0 w-8 h-8 border-t-2 border-r-2 border-chart-3 rounded-tr-3xl translate-x-[2px] -translate-y-[2px]" />
            <div className="absolute bottom-0 left-0 w-8 h-8 border-b-2 border-l-2 border-chart-3 rounded-bl-3xl -translate-x-[2px] translate-y-[2px]" />
            <div className="absolute bottom-0 right-0 w-8 h-8 border-b-2 border-r-2 border-chart-3 rounded-br-3xl translate-x-[2px] translate-y-[2px]" />

            <div className="inline-flex items-center justify-center p-3 bg-chart-3/10 rounded-full mb-8 ring-1 ring-chart-3/30">
              <Crown className="size-8 text-chart-3" />
            </div>

            <h2 className="text-3xl md:text-5xl lg:text-6xl font-default font-bold mb-6 text-primary-foreground tracking-tight">
              The Founders Circle
            </h2>
            
            <p className="text-lg md:text-xl mb-10 text-primary-foreground/80 max-w-2xl mx-auto leading-relaxed font-default">
              Become a special part of our initial supporters helping build the foundation for long-term impact, future growth, and transformational community support. Your commitment today ensures dignity and opportunity for generations to come.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link to="/SupportUsPage">
                <Button size="lg" className="bg-chart-3 text-primary hover:bg-chart-3/90 text-lg px-8 py-6 rounded-full font-semibold shadow-lg shadow-chart-3/20 transition-all hover:scale-105">
                  <Sparkles className="mr-2 size-5" />
                  Join the Circle
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}